<template>
	<AppPopup
		ref="popup"
		:title="languageStore.getString('link_consumer_popup_title')"
		:buttons="popupButtons"
		:prevent-overlay-dismiss="true"
		@toggling-popup="onToggle"
	>
		<div class="consumer-link-preview" v-if="consumer">
			<img v-if="consumer.picture_url" :src="consumer.picture_url" class="consumer-pic" alt=""/>
			<p class="consumer-name">{{ consumer.name || languageStore.getString('account_unnamed_user') }}</p>
			<p class="consumer-email" v-if="consumer.email">{{ consumer.email }}</p>
		</div>
	</AppPopup>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";
import {useCustomersStore} from "@/console-new/stores";
import AppPopup from "@/shared/components/AppPopup.vue";

export default {
	name: "ConsumerLinkPopup",
	emits: ['closed'],
	components: {AppPopup},
	setup() {
		const languageStore = useLanguageStore();
		const customersStore = useCustomersStore();
		return {languageStore, customersStore};
	},
	data() {
		return {
			consumer: null,
			consumerToken: null,
			creatingCustomer: false,
		};
	},
	computed: {
		popupButtons() {
			return [
				{
					text: this.languageStore.getString('cancel'),
					negative: true,
					loading: this.creatingCustomer,
					callback: this.onCancel,
				},
				{
					text: this.languageStore.getString('create_customer'),
					loading: this.creatingCustomer,
					callback: this.onConfirm,
				},
			];
		},
	},
	methods: {
		open(consumer, consumerToken) {
			this.consumer = consumer;
			this.consumerToken = consumerToken;
			this.creatingCustomer = false;
			this.$nextTick(() => {
				if(this.$refs.popup) {
					this.$refs.popup.toggleStatus(true);
				}
			});
		},
		onConfirm() {
			// TODO: future enhancement — let the cashier pick an existing UNLINKED customers_people
			// row (no consumer_id) to attach this consumer to instead of always creating new. Would
			// need a search/picker UI + a backend method that updates customers_people.consumer_id.
			if(this.creatingCustomer) { return; }
			this.creatingCustomer = true;
			this.customersStore.createCustomerFromConsumerToken(this.consumerToken, () => {
				this.creatingCustomer = false;
				if(this.$refs.popup) {
					this.$refs.popup.toggleStatus(false);
				}
			}, () => {
				this.creatingCustomer = false;
			});
		},
		onCancel() {
			if(this.creatingCustomer) { return; }
			if(this.$refs.popup) {
				this.$refs.popup.toggleStatus(false);
			}
		},
		onToggle(isOpen) {
			if(!isOpen) {
				this.consumer = null;
				this.consumerToken = null;
				this.$emit('closed');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.consumer-link-preview {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	padding: 10px 0;
}

.consumer-pic {
	width: 80px;
	height: 80px;
	border-radius: 50%;
	object-fit: cover;
}

.consumer-name {
	margin: 0;
	font-size: 18px;
	font-weight: 600;
	color: var(--color-txt);
	text-align: center;
	word-break: break-word;
}

.consumer-email {
	margin: 0;
	font-size: 14px;
	font-weight: 400;
	color: var(--color-txt);
	opacity: 0.7;
	text-align: center;
	word-break: break-word;
}
</style>